const {
  icons: icons$1
} = window.theme;
document.addEventListener('quickview:loaded', () => {

  if (window.matchMedia("(min-width: 720px)").matches){
      document.querySelector('.quick-product .product__media').style.transform = 'translateY(0)';
      let swiperNode = document.querySelector('.quick-product .quick-view-swiper-container')
      let swiperArgs = {
        direction: 'vertical',
        navigation: {
          nextEl: ".quick-view-next",
          prevEl: ".quick-view-prev",
        },
        spaceBetween: 10,
        slidesPerView: 3,
        hashNavigation: true
       }
      import(flu.chunks.swiper).then(res => {
              let {
        Swiper,
        Navigation,
        Autoplay,
        Pagination
      } = res;
      swiperArgs.modules = [Navigation, Autoplay, Pagination]
      const quickViewSwiper = new Swiper(swiperNode, swiperArgs)
      quickViewSwiper.on('slideChange', () => {
        let currentIndex = quickViewSwiper.activeIndex;
        if (currentIndex === 0) {
          document.querySelector('.quick-view-prev').setAttribute('disabled', '')
        } else {
          document.querySelector('.quick-view-prev').removeAttribute('disabled')
        }
        if (currentIndex >= ((quickViewSwiper.slides.length /2))){
          document.querySelector('.quick-view-next').setAttribute('disabled', '')
        } else {
          document.querySelector('.quick-view-next').removeAttribute('disabled')
        }
       })
      })
      //swatch color change variant image
      if(document.querySelector('[data-quick-view-modal] .product__color-swatches')){
        document.querySelectorAll('[data-quick-view-modal] .product__color-swatches .product__color-swatch').forEach(item => {
          item.addEventListener('click', () => {
            let currentColor = item.getAttribute('data-option-value')
            let currentColorLowCase = currentColor.toLowerCase()
            let allSlides = document.querySelectorAll('[data-quick-view-modal] .product__media .swiper-slide')
            for(let a = 0; a < allSlides.length; a++){
              if(allSlides[a].getAttribute('data-image-handle').includes(currentColorLowCase) || allSlides[a].getAttribute('data-image-alt').includes(currentColor) || allSlides[a].getAttribute('data-image-alt').includes(currentColorLowCase)){
                document.querySelector('.quick-product .quick-view-swiper-container').swiper.slideTo(a)
                break
              }
            }
          })
        })
      }
      

      if (document.querySelector('.quick-product .product__media')){
          import(flu.chunks.photoswipe).then(_ref => {
              let {
                PhotoSwipeLightbox,
                PhotoSwipe
              } = _ref;
              productLightbox = new PhotoSwipeLightbox({
                gallery: ".lightbox-media-container",
                children: ".lightbox-image",
                pswpModule: PhotoSwipe,
                mainClass: "pswp--product-lightbox",
                bgOpacity: 1,
                arrowPrevSVG: icons$1.chevron,
                arrowNextSVG: icons$1.chevron,
                closeSVG: icons$1.close,
                zoomSVG: icons$1.zoom
              });
              productLightbox.init();
          
              // Hide nav ui elements if single image
              productLightbox.on("firstUpdate", () => {
                const {
                  pswp,
                  options
                } = productLightbox;
                const productImageCount = options.dataSource.items.length;
                if (productImageCount === 1) {
                  u$1(pswp.element, "pswp--is-single-image");
                }
              });
          });
      }
  }
})

document.addEventListener('product:variant-change', (evt) => {
  const { variant } = evt.detail

  const quantityEl = document.querySelector('.product__meta .product__controls-group.product__controls-group-quantity')
  const submitBtnEl = document.querySelector('.product__meta .product-form__item--payment-button')

  if (quantityEl) {
    quantityEl.style.display = variant.available ? 'block' : 'none'
  }

  if (submitBtnEl) {
    submitBtnEl.style.display = variant.available ? 'block' : 'none'
  }

  const addToCartButton = evt.detail.container.querySelector('[data-add-to-cart]')
  const bisForm = evt.detail.container.querySelector('custom-swym-bis-alert')

  if (evt.detail.container && bisForm) {

      if (variant && variant.available === false) {
        bisForm.setAttribute('data-variant-id', variant.id)
        bisForm.setAttribute('data-variant-price', variant.price / 100)
        bisForm.setAttribute('data-variant-image', variant.featured_image?.src ?? '')

        bisForm.style.display = 'block'

        addToCartButton.style.display = 'none'
      } else {
        bisForm.style.display = 'none'
        addToCartButton.style.display = 'block'
      }
  } else {
    addToCartButton.style.display = 'block'
  }
})

customElements.define('custom-swym-bis-alert', class CustomSwymBisAlert extends HTMLElement {
  constructor () {
    super()

    this.emailInput = this.querySelector('[data-bis-input]')
    this.submitButton = this.querySelector('[data-bis-submit]')
    this.message = this.querySelector('[data-message]')
    this.successMessage = this.getAttribute('data-success-message')
    this.errorMessage = this.getAttribute('data-error-message')

    this.initEvents()
  }

  validateEmail () {
    const email = this.emailInput.value.trim()
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!emailPattern.test(email)) {
      // Add error classes
      this.emailInput.classList.add('error')
      this.message.classList.add('error')
      this.message.textContent = this.errorMessage
      return false
    } else {
      // Remove error classes
      this.emailInput.classList.remove('error')
      this.message.classList.remove('error')
      this.message.textContent = ''
      return true
    }
  }

  async onSubmit () {
    if (this.validateEmail()) {

      // Refer to https://developers.swym.it/docs/request-a-back-in-stock-alert
      const swymProductData = {
        epi: Number(this.getAttribute('data-variant-id')),
        empi: Number(this.getAttribute('data-product-id')),
        du: this.getAttribute('data-product-url]'),
        iu: this.getAttribute('data-variant-image'), 
        pr: Number(this.getAttribute('data-variant-price')),
        et: 8 
      }

      const onSuccess = (response) => {
        console.log(response, 'Successfully subscribed')

        this.emailInput.value = ''
        this.message.classList.add('success')
        this.message.textContent = this.successMessage

        setTimeout(() => {
          this.message.classList.remove('success')
          this.message.textContent = ''
        }, 10000)
      }

      const onError = (error) => {
        console.log(error, 'Error subscribing')

        this.message.classList.add('error')
        this.emailInput.classList.add('error')
        this.message.textContent = this.errorMessage
      }

      await window._swat.sendWatchlist(
        this.emailInput.value.trim(),
        'email',
        swymProductData,
        onSuccess,
        onError,
      )
    }
  }

  initEvents () {
    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault()
      this.onSubmit()  
    })

    this.emailInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault(); 
        this.onSubmit();
      }
    })
  }
})

// adds youtube video iframe aria-label and title
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('iframe')) {
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach((iframe) => {
      if (iframe.src.includes('youtube.com')) {
        iframe.setAttribute('aria-label', `Watch ${iframe.src}`);
      }
    })
  }
});